module.exports = __webpack_public_path__ + "img/restart.fe1fd33a.png";